import React from 'react';
import { Link } from 'react-router-dom';
import { PenSquare } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-400 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 text-white font-bold text-lg mb-3">
              <PenSquare className="w-5 h-5" />
              EZSig
            </div>
            <p className="text-sm">Sign, brand, and create — all in one place.</p>
          </div>
          <div>
            <h4 className="text-white font-medium mb-3">Products</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/esign" className="hover:text-white transition-colors">eSign</Link></li>
              <li><Link to="/email-signatures" className="hover:text-white transition-colors">Email Signatures</Link></li>
              <li><Link to="/social" className="hover:text-white transition-colors">Social Animations</Link></li>
              <li><Link to="/ai-images" className="hover:text-white transition-colors">AI Images</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-medium mb-3">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link></li>
              <li><a href="mailto:support@ezsig.com" className="hover:text-white transition-colors">Support</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-medium mb-3">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-6 text-center text-sm">
          © {new Date().getFullYear()} EZSig. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
